import React, { useEffect } from "react";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import RelatedWorks from "./RelatedWorks";
import "./Mgrdetail.css";

export default function VelammalNexuxDetails() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="work-detail-page">
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 1000 }}>
        <Navbar />
      </div>

      <section className="project-info-section">
        <h1 className="project-title-heading">
          Velammal Nexus – Newspaper Ads & Billboards
        </h1>

        <p className="project-description">
          We designed and developed high-impact brand communication campaigns for Velammal Nexus, creating striking newspaper advertisements and outdoor billboard designs. Our creative approach focused on capturing the institution's academic achievements and community presence through premium print layouts and grand-scale billboard campaigns, ensuring strong local engagement and brand recognition.
        </p>

        <div className="project-tags">
          <span className="info-tag">Newspaper Advertisement</span>
          <span className="info-tag">Billboard Design</span>
          <span className="info-tag">Brand Communication</span>
          <span className="info-tag">Outdoor Advertising</span>
          <span className="info-tag">Print Design</span>
          <span className="info-tag">Educational Branding</span>
        </div>
      </section>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/VelammalNexux/Full1.webp" alt="Velammal Nexus Campus Showcase" />
      </div>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/VelammalNexux/Full2.webp" alt="Velammal Nexus Newspaper Advertisement 1" />
      </div>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/VelammalNexux/Full3.webp" alt="Velammal Nexus Newspaper Advertisement 2" />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We designed high-impact newspaper advertisements for Velammal Nexus that balance structured academic communication with premium layouts, maximizing reader engagement in print media."
        </div>
      </section>
     
      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/VelammalNexux/Full4.webp" alt="Velammal Nexus Billboard 1" />
      </div>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/VelammalNexux/Full5.webp" alt="Velammal Nexus Billboard 2" />
      </div>


      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "Our grand-scale outdoor billboard campaigns for Velammal Nexus were engineered to capture attention, ensuring high brand visibility and local presence across key urban hubs."
        </div>
      </section>

      <RelatedWorks excludePath="/works/velammalnexux" />
      <Footer />
    </div>
  );
}
